var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCardiologistIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame 33"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 8,
    fill: "#1C84CF"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M6.11325 19.5409C5.69313 16.6007 6.41333 13.6605 8.75397 11.2765C10.9346 9.07133 14.0954 7.38267 17.8365 8.21706C20.8773 8.89252 22.8378 11.0182 23.6381 12.1109C23.8181 12.3493 24.1782 12.3493 24.3583 12.1109C25.1785 11.0381 27.119 8.91238 30.1599 8.21706C33.9009 7.38267 37.0617 9.07133 39.2423 11.2765C45.144 17.2364 40.6827 26.6729 34.221 31.0237C31.5602 32.8116 27.5191 35.6525 25.6386 37.4802C25.0985 37.9968 24.6583 38.4735 24.3382 38.851C24.1582 39.0497 23.8581 39.0497 23.6781 38.851C23.358 38.4735 22.9179 37.9968 22.3777 37.4802C20.4972 35.6724 16.4361 32.8315 13.7954 31.0237C11.5347 29.494 9.87428 27.9245 8.45389 25.5207",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M6.95337 22.6401H12.2548L13.8353 20.0972L15.9758 25.8386L18.4965 13.1042L21.3973 29.5933L25.0183 19.5012L27.1789 25.8783L29.0995 22.6401H34.0408",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M34.0403 24.2096C34.9129 24.2096 35.6203 23.5069 35.6203 22.6401C35.6203 21.7734 34.9129 21.0707 34.0403 21.0707C33.1677 21.0707 32.4603 21.7734 32.4603 22.6401C32.4603 23.5069 33.1677 24.2096 34.0403 24.2096Z",
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardiologistIcon);
export default __webpack_public_path__ + "static/media/cardiologistIcon.b2b5e07197dfcf44b9df7f46b3e631c7.svg";
export { ForwardRef as ReactComponent };